// bce-storage.js 文档：http://wiki.baidu.com/pages/viewpage.action?pageId=1593070933
// 需求卡片：https://console.cloud.baidu-int.com/devops/icafe/issue/EOP--IRM-1307/show
import bceStorage from '@baidu/bce-storage';
import {API} from '../api';

// 需要接入OCPC的接口
export const API_NEED_OCPC = {
    // 个人刷脸
    [API.personFaceSubmit]: true,
    // 个人证件认证
    [API.submitPersonCertificate]: true,
    // 个人银行卡
    [API.submitPerBank]: true,
    // 企业对公打款
    [API.submitCompTransfer]: true,
    // 企业充值认证
    [API.submitPayment]: true,
    // 企业法人刷脸
    [API.legalLivingSubmit]: true,
    // 企业被授权人刷脸
    [API.legalAuthorizedLivingSubmit]: true,
};

export function initBceStorage(isOnline: boolean) {
    const env = isOnline ? 'ONLINE' : 'SANDBOX';
    bceStorage.init(env);
}

export function getOcpcParams() {
    if (bceStorage && bceStorage.get) {
        return bceStorage
            .get({
                key: 'ocpc_params',
                storage: 'localStorage',
            })
            .then(data => {
                return new Promise((resolve, reject) => {
                    try {
                        const jsonData = JSON.parse(data);
                        if (jsonData && jsonData.content) {
                            const {content} = jsonData;
                            const params = {
                                content: {
                                    bdVid: content.bd_vid,
                                    track: content.track,
                                    url: content.url,
                                },
                            };
                            resolve(params);
                        }
                        else {
                            reject(new Error('获取OCPC参数失败'));
                        }
                    }
                    catch (e) {
                        reject(new Error('获取OCPC参数失败'));
                    }
                });
            });
    }
    return Promise.resolve();
}

export function getOcpcParam(url: string): Promise<any> {
    const needOCPC = API_NEED_OCPC[url];
    if (needOCPC) {
        return getOcpcParams().then(content => {
            return content;
        }).catch(() => Promise.resolve({}));
    }
    return Promise.resolve({});
}
